<template>
<div>
  <data-local-table
    :fields="fields"
    :items="value"
  >
    <template
      slot="actions"
      slot-scope="slotData"
    >
      <v-btn
        x-small
        color="primary"
        @click="showEditDialog(slotData.rowIndex, slotData.rowData)"
      >Edit</v-btn>
    </template>
  </data-local-table>
  <v-btn
    color="primary"
    small
    @click="showAddDialog()"
  >
    Add equipment
  </v-btn>
  <modal-form
    title="Equipment"
    :show="dialog"
    @update:show="dialog=$event"
    v-on:saveData="doSave"
  >
    <v-form v-model="valid">
      <v-row>
        <v-col cols="4">
          <equipment-type
            :readonly="isReadOnly()"
            label="Equipment type"
            :value="getValue(item, 'equipment_type')"
            @input="setValue(item, 'equipment_type', $event)"
          ></equipment-type>
        </v-col>
        <v-col cols="4">
          <i-p-adress
            :readonly="isReadOnly()"
            label="IP Address"
            :value="getValue(item, 'ip_address')"
            @input="setValue(item, 'ip_address', $event)"
          ></i-p-adress>
        </v-col>
        <v-col cols="4">
          <text-field
            :readonly="isReadOnly()"
            label="Hostname"
            :value="getValue(item, 'hostname')"
            @input="setValue(item, 'hostname', $event)"
          ></text-field>
        </v-col>
      </v-row>
    </v-form>
    <h3>Cards</h3>
    <cards-list
      :site="site"
      :value="getValue(item, 'cards')"
      @input="setValue(item, 'cards', $event)"
    ></cards-list>
  </modal-form>
</div>
</template>

<script>
  import ModalForm from '@/components/ModalForm'
  import EquipmentType from '@/components/codelist/EquipmentType'
  import IPAdress from '@/components/IPAddress'
  import TextField from '@/components/TextField'
  import CardsList from '@/views/sites/sections/transmission-equipment/CardsList'
  import DataTable from '@/components/DataTable'
  import ReactivityMixin from '@/mixins/Reactivity'
  import DataLocalTable from '@/components/DataLocalTable'
  import PermissionsMixin from '@/mixins/Permissions'
  export default {
    name: 'TransmissionEquipmentList',
    components: { DataLocalTable, DataTable, CardsList, TextField, IPAdress, EquipmentType, ModalForm },
    mixins: [
      ReactivityMixin,
      PermissionsMixin,
    ],
    props: {
      value: {
        default: [],
      },
      site: {},
    },
    data: function () {
      return {
        dialog: false,
        selected_index: -1,
        item: {},
        valid: false,
        fields: [
          {
            name: 'equipment_type',
            title: 'Equipment type',
          },
          {
            name: 'ip_address',
            title: 'IP address',
          },
          {
            name: 'hostname',
            title: 'Hostname',
          },
          {
            name: '__slot:actions',
            title: 'Actions',
          },
        ],
        section: 'transmission_equipment',
      }
    },
    computed: {
      isEditing () {
        return this.selected_index > -1
      },
    },
    watch: {
      value: function () {
        this.$emit('input', this.value)
      },
    },
    methods: {
      showAddDialog () {
        this.selected_index = -1
        this.item = {
          cards: [],
        }
        this.dialog = true
      },
      showEditDialog (index, data) {
        this.item = data
        this.selected_index = index
        this.dialog = true
      },
      doSave () {
        if (this.valid) {
          if (this.selected_index > -1) {
            this.value[this.selected_index] = this.item
            this.dialog = false
          } else {
            this.value.push(this.item)
            this.dialog = false
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>
